import { Directive, Input, TemplateRef, ViewContainerRef, OnDestroy, EmbeddedViewRef } from '@angular/core'
import { AuthService } from '../services/auth.service'

// eslint-disable-next-line @angular-eslint/directive-selector -- legacy selector used app-wide; renaming is a breaking sweep (YB-1951)
@Directive({ selector: '[hasPermission]', standalone: false })
export class HasPermissionDirective implements OnDestroy {
  permission: string
  private embeddedViewRef: EmbeddedViewRef<unknown> | null = null

  constructor(private authService: AuthService, private templateRef: TemplateRef<unknown>, private viewContainer: ViewContainerRef) {}

  @Input()
  set hasPermission(val: string) {
    this.permission = val
    this.updateView()
  }

  private updateView() {
    if (this.checkPermission()) {
      if (!this.embeddedViewRef) {
        this.embeddedViewRef = this.viewContainer.createEmbeddedView(this.templateRef)
      }
    } else {
      this.clearView()
    }
  }

  private clearView() {
    if (this.embeddedViewRef) {
      this.embeddedViewRef.destroy()
      this.embeddedViewRef = null
    }
    this.viewContainer.clear()
  }

  private checkPermission() {
    const currentUser = this.authService.user
    if (!currentUser || !currentUser.role || !currentUser.role.permissions) {
      return false
    }
    return currentUser.role.permissions.includes(this.permission)
  }

  ngOnDestroy() {
    this.clearView()
  }
}
